import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import HeroCarousel from "../components/HeroCarousel";
import HowItWorks from "../components/HowItWorks";
import Products from "../components/Products";
import Services from "../components/Services";
import BeerCalculator from "../components/BeerCalculator";
import About from "../components/About";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const HomePage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const targetId = location.state?.scrollTo;
    if (!targetId) return;

    let cleared = false;

    const clearState = () => {
      if (cleared) return;
      cleared = true;
      navigate(location.pathname, { replace: true, state: {} });
    };

    const scrollToTarget = () => {
      if (targetId === 'top') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        clearState();
        return true;
      }

      const target = document.getElementById(targetId);
      if (!target) return false;

      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      clearState();
      return true;
    };

    const attemptNow = scrollToTarget();

    if (!attemptNow) {
      const t1 = window.setTimeout(scrollToTarget, 120);
      const t2 = window.setTimeout(scrollToTarget, 320);
      const t3 = window.setTimeout(scrollToTarget, 700);

      return () => {
        window.clearTimeout(t1);
        window.clearTimeout(t2);
        window.clearTimeout(t3);
      };
    }
  }, [location, navigate]);

  return (
    <>
      <Header />
      <main>
        <HeroCarousel />
        <HowItWorks />
        <Products />
        <Services />
        <BeerCalculator />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
